import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

/**
 * Custom hook for managing Audit Logs and Rollback logic.
 */
export const useAuditLogs = (user, authLoading) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchLogs = useCallback(async () => {
    if (authLoading || user?.type !== 'admin') return;
    
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get('/api/audit');
      setLogs(res.data);
    } catch (err) {
      console.error('Error fetching audit logs:', err);
      setError('Failed to load audit trail.');
    } finally {
      setLoading(false);
    }
  }, [user?.type, authLoading]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  const handleRollback = async (logId) => {
    if (!window.confirm('Are you sure you want to rollback this change? This will restore the previous values for the modified fields.')) {
      return;
    }

    try {
      await axios.post(`/api/audit/${logId}/rollback`);
      alert('Rollback successful!');
      fetchLogs(); // Refresh the list to show the new rollback log entry
      return true;
    } catch (err) {
      alert(err.response?.data?.msg || 'Error performing rollback');
      return false;
    }
  };

  return {
    logs,
    loading,
    error,
    fetchLogs,
    handleRollback
  };
};
